import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { baseURL } from "../utils/config";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from "sweetalert2";
import { useSidebar } from '../context/SidebarContext';

const ModifierCompte = () => {
  const { authTokens, user, logoutUser } = useAuth(); // ✅ updateUserInfo retiré, plus nécessaire
  const { sidebarVisible } = useSidebar();

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    first_name: "",
    last_name: "",
    poste: "",
    telephone: "",
    old_password: "",
    new_password: "",
    confirm_password: "",
    image: null,
  });

  const hasAdminPermissions = user && (
    user.is_super_admin ||
    user.permissions?.includes("VIEW_DASHBOARD") ||
    user.permissions?.includes("VIEW_PRESENCE") ||
    user.permissions?.includes("VIEW_EMPLOYE") ||
    user.permissions?.includes("VIEW_STATISTICS") ||
    user.permissions?.includes("VIEW_JUSTIFICATION") ||
    user.permissions?.includes("VIEW_PENALITE") ||
    user.permissions?.includes("VIEW_PRIME") ||
    user.permissions?.includes("VIEW_POINTAGE_MANUEL") ||
    user.permissions?.includes("VIEW_CONFIGURATION")
  );

  const showSidebar = sidebarVisible && hasAdminPermissions;

  useEffect(() => {
    if (user) {
      setFormData({
        username: user.username || "",
        email: user.email || "",
        first_name: user.first_name || "",
        last_name: user.last_name || "",
        poste: user.poste || "",
        telephone: user.telephone || "",
        old_password: "",
        new_password: "",
        confirm_password: "",
        image: null,
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setFormData({ ...formData, image: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { old_password, new_password, confirm_password } = formData;
    const wantsToChangePassword = old_password || new_password || confirm_password;

    if (wantsToChangePassword) {
      if (!old_password || !new_password || !confirm_password) {
        return Swal.fire("Erreur", "Veuillez remplir tous les champs de mot de passe ou les laisser vides.", "error");
      }
      if (new_password !== confirm_password) {
        return Swal.fire("Erreur", "Les mots de passe ne correspondent pas.", "error");
      }
    }

    const dataToSend = new FormData();
    Object.entries({
      username: formData.username,
      email: formData.email,
      first_name: formData.first_name,
      last_name: formData.last_name,
      poste: formData.poste,
      telephone: formData.telephone,
    }).forEach(([key, value]) => dataToSend.append(key, value));

    if (formData.image) dataToSend.append("image", formData.image);
    if (wantsToChangePassword) {
      dataToSend.append("old_password", old_password);
      dataToSend.append("password", new_password);
      dataToSend.append("password2", confirm_password);
    }

    try {
      const res = await fetch(`${baseURL}/mon-compte/`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
        body: dataToSend,
      });

      if (res.ok) {
        // ✅ Dans tous les cas → déconnexion propre après toute modification
        await Swal.fire({
          title: "Profil mis à jour",
          html: `
            <p>Vos informations ont été modifiées avec succès.</p>
            <p style="color:#888; font-size:14px;">
              Veuillez vous reconnecter pour continuer.
            </p>
          `,
          icon: "success",
          confirmButtonText: "Se reconnecter",
          confirmButtonColor: "#1B019B",
          allowOutsideClick: false,
        });
        logoutUser(true); // silent = true, le swal est déjà affiché

      } else {
        const err = await res.json();

        // ✅ Affichage propre des erreurs de validation Django
        const errorMessages = Object.entries(err)
          .map(([field, messages]) => {
            const label = {
              old_password: "Ancien mot de passe",
              password: "Nouveau mot de passe",
              password2: "Confirmation",
              username: "Nom d'utilisateur",
              email: "Email",
            }[field] || field;
            return `<b>${label}</b> : ${Array.isArray(messages) ? messages.join(", ") : messages}`;
          })
          .join("<br/>");

        Swal.fire({
          title: "Erreur de validation",
          html: errorMessages,
          icon: "error",
          confirmButtonColor: "#1B019B",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Erreur réseau",
        text: "Impossible de contacter le serveur. Vérifiez votre connexion.",
        icon: "error",
        confirmButtonColor: "#1B019B",
      });
    }
  };

  return (
    <div
      style={{
        marginLeft: showSidebar ? 250 : 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ padding: "30px", backgroundColor: "#f4f6f9", flex: 1 }}>
        <div className="text-center mb-4">
          <h4 className="fw-bold" style={{ color: "#1B019B" }}>Modifier Mon Compte</h4>
          <div style={{ width: "60px", height: "4px", backgroundColor: "#1B019B", margin: "0 auto", borderRadius: "2px" }}></div>
        </div>

        <form
          onSubmit={handleSubmit}
          className="mx-auto shadow-sm"
          style={{
            backgroundColor: "#fff",
            padding: "30px",
            borderRadius: "16px",
            maxWidth: "900px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
          }}
        >
          <div className="row g-4">
            <div className="col-md-6">
              <label className="form-label fw-semibold">Nom d'utilisateur</label>
              <input name="username" value={formData.username} onChange={handleChange} className="form-control" required />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Prénom</label>
              <input name="first_name" value={formData.first_name} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Nom</label>
              <input name="last_name" value={formData.last_name} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Poste</label>
              <input name="poste" value={formData.poste} onChange={handleChange} className="form-control" />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Téléphone</label>
              <input name="telephone" value={formData.telephone} onChange={handleChange} className="form-control" />
            </div>

            {/* Séparateur section mot de passe */}
            <div className="col-12">
              <hr style={{ borderColor: "#e0e0e0" }} />
              <p className="fw-semibold mb-0" style={{ color: "#1B019B", fontSize: "14px" }}>
                Changer le mot de passe — laisser vide pour ne pas modifier
              </p>
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Ancien mot de passe</label>
              <div className="input-group">
                <input
                  type={showOldPassword ? "text" : "password"}
                  name="old_password"
                  value={formData.old_password}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Entrez votre ancien mot de passe"
                />
                <span className="input-group-text" onClick={() => setShowOldPassword(!showOldPassword)} style={{ cursor: "pointer" }}>
                  {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Nouveau mot de passe</label>
              <div className="input-group">
                <input
                  type={showNewPassword ? "text" : "password"}
                  name="new_password"
                  value={formData.new_password}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Entrez votre nouveau mot de passe"
                />
                <span className="input-group-text" onClick={() => setShowNewPassword(!showNewPassword)} style={{ cursor: "pointer" }}>
                  {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Confirmer le mot de passe</label>
              <div className="input-group">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirm_password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Confirmez le nouveau mot de passe"
                />
                <span className="input-group-text" onClick={() => setShowConfirmPassword(!showConfirmPassword)} style={{ cursor: "pointer" }}>
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold">Image de profil</label>
              <input type="file" name="image" onChange={handleChange} className="form-control" accept="image/*" />
            </div>
          </div>

          <div className="text-end mt-4">
            <button
              type="submit"
              className="btn d-flex align-items-center justify-content-center gap-2"
              style={{
                backgroundColor: '#1B019B',
                color: '#fff',
                padding: '10px 24px',
                borderRadius: '30px',
                fontWeight: '600',
                fontSize: '16px',
                boxShadow: '0 4px 10px rgba(27, 1, 155, 0.3)',
                marginLeft: 'auto',
              }}
            >
              Sauvegarder les modifications
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModifierCompte;